<template>
  <div class="camera-access-view">
    <!-- Dialog de Configuración de IP -->
    <v-dialog v-model="dialogIP" persistent width="400">
      <v-card class="justify-center">
        <v-toolbar dark color="primary">
          <v-toolbar-title>Configurar IP del Servidor</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="align-self-end" color="red" icon @click="dialogIP = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-text-field
            v-model="serverIP"
            outline
            label="IP del Servidor"
            placeholder="192.168.1.50:7000"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="saveServerIP()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Opciones de Cámaras -->
    <v-dialog v-model="dialogCameraOptions" persistent width="400">
      <v-card class="justify-center">
        <v-toolbar dark color="primary">
          <v-toolbar-title>Opciones de Cámaras</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="align-self-end" color="red" icon @click="dialogCameraOptions = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-btn
            block
            color="primary"
            @click="loadCameras(); dialogCameraOptions = false"
            :loading="loadingCameras"
            class="mb-3"
          >
            <v-icon left>refresh</v-icon>
            Recargar Cámaras
          </v-btn>
          <v-btn
            block
            color="warning"
            @click="dialogRestartCamera = true; dialogCameraOptions = false"
            :disabled="cameras.length === 0"
            class="mb-3"
          >
            <v-icon left>restart_alt</v-icon>
            Reiniciar Cámaras
          </v-btn>
          <v-btn
            block
            color="error"
            @click="dialogRestartDevice = true; dialogCameraOptions = false"
            :disabled="cameras.length === 0"
          >
            <v-icon left>power_settings_new</v-icon>
            Reiniciar Dispositivo
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de Selección de Cámara para Restart -->
    <v-dialog v-model="dialogRestartCamera" persistent width="400">
      <v-card class="justify-center">
        <v-toolbar dark color="warning">
          <v-toolbar-title>Reiniciar Cámara</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="align-self-end" color="red" icon @click="dialogRestartCamera = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-select
            v-model="selectedCameraToRestart"
            :items="camerasForRestart"
            item-text="name"
            item-value="id"
            label="Selecciona una cámara"
            outlined
          ></v-select>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn color="grey" @click="dialogRestartCamera = false">Cancelar</v-btn>
          <v-btn
            color="warning"
            @click="executeRestartCamera()"
            :loading="loadingRestart"
            :disabled="!selectedCameraToRestart"
          >
            Reiniciar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Selección de Cámara para Restart de Dispositivo -->
    <v-dialog v-model="dialogRestartDevice" persistent width="400">
      <v-card class="justify-center">
        <v-toolbar dark color="error">
          <v-toolbar-title>Reiniciar Dispositivo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="align-self-end" color="red" icon @click="dialogRestartDevice = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-select
            v-model="selectedCameraToRestartDevice"
            :items="camerasForRestart"
            item-text="name"
            item-value="id"
            label="Selecciona una cámara"
            outlined
          ></v-select>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn color="grey" @click="dialogRestartDevice = false">Cancelar</v-btn>
          <v-btn
            color="error"
            @click="dialogConfirmRestartDevice = true"
            :disabled="!selectedCameraToRestartDevice"
          >
            Siguiente
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Confirmación con Advertencia -->
    <v-dialog v-model="dialogConfirmRestartDevice" persistent width="450">
      <v-card class="justify-center">
        <v-toolbar dark color="error">
          <v-icon left class="mr-2">warning</v-icon>
          <v-toolbar-title>Advertencia de Reinicio</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="align-self-end" color="red" icon @click="dialogConfirmRestartDevice = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-6">
          <v-card class="mb-4 elevation-0" style="background-color: #fff3cd; border-left: 4px solid #ff9800;">
            <v-card-text class="pa-3">
              <div class="subheading font-weight-bold mb-3">Atención - Reinicio Completo del Dispositivo</div>
              <div class="body2 mb-3">
                Esta acción reiniciará completamente el dispositivo de la cámara.
              </div>
              <div class="font-weight-bold mb-2 body2">Durante este proceso:</div>
              <ul class="ml-4 body2">
                <li>La cámara se desconectará inmediatamente</li>
                <li>El servicio no estará disponible durante 1-2 minutos</li>
              </ul>
              <div class="font-weight-bold mt-4 body2 error--text">¿Estás completamente seguro?</div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center pa-4">
          <v-btn color="grey" @click="dialogConfirmRestartDevice = false" large>Cancelar</v-btn>
          <v-btn
            color="error"
            @click="executeRestartDevice()"
            :loading="loadingRestartDevice"
            large
          >
            <v-icon left>power_settings_new</v-icon>
            Sí, Reiniciar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Errores -->
    <v-dialog v-model="dialogError" persistent width="400">
      <v-card class="justify-center">
        <v-card-title class="red white--text">Error</v-card-title>
        <v-card-text>
          <h3 class="text-xs-center">{{ errorMessage }}</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="closeErrorDialog()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Éxito -->
    <v-dialog v-model="dialogSuccess" persistent width="400">
      <v-card class="justify-center">
        <v-card-title class="green white--text">Éxito</v-card-title>
        <v-card-text>
          <h3 class="text-xs-center">{{ successMessage }}</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="closeSuccessDialog()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Errores -->
    <v-dialog v-model="dialog_errores" persistent width="400">
      <v-card class="justify-center">
        <v-card-title :class="head_color" primary-title>
          {{$t('aviso')}}
        </v-card-title>
        <v-card-text>
          <h3 class="text-xs-center">{{errores_guard}}</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn
            v-if="band_gafete"
            color="primary"
            x-small
            :loading="loading_gafete"
            @click="download_gafete"
          >{{$t('print_name_tag')}}</v-btn>
          <v-btn color="primary" @click="closeGuardErrorDialog()">
            {{$t('aceptar')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Selección de Caseta -->
    <v-dialog v-model="dialog_inicio" persistent max-width="400px">
      <v-form @submit.prevent="set_caseta()">
        <v-card class="justify-center">
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{$t('selecciona_caseta')}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-autocomplete
              v-model="caseta"
              name="caseta"
              :items="casetas"
              item-text="name"
              item-value="id"
              return-object
              :label="$t('Casetas')"
              :loading="loading"
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" type="submit">{{ $t('aceptar') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Dialog de Información de Invitación -->
    <v-dialog v-model="dialog" persistent scrollable max-width="500">
      <!-- ENTRADA -->
      <v-card v-if="entrada" color="blue-grey lighten-4" class="elevation-5 center">
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="align-self-end" color="red" icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '0'" class="pa-4">
          <div class="text-center mb-4">
            <v-img
              :src="info_invitation.guest_Avatar || info_invitation.avatar"
              position="center center"
              class="grey lighten-2 elevation-2"
              style="border-radius: 12px; max-height: 200px; max-width: 200px; margin: 0 auto;"
            ></v-img>
          </div>
          <v-card class="mb-3 elevation-1" color="primary">
            <v-card-text class="white--text pa-3 text-center">
              <div class="caption white--text opacity-9 mb-1">{{$t('Visitante')}}</div>
              <div class="subheading font-weight-bold white--text">{{ info_invitation.guestFirstName}} {{ info_invitation.guestLastName}}</div>
            </v-card-text>
          </v-card>
          <v-card class="elevation-1" color="primary">
            <v-card-text class="white--text pa-3 text-center">
              <div class="caption white--text opacity-9 mb-1">{{$t('Empresa')}}</div>
              <div class="subheading font-weight-bold white--text">{{ info_invitation.empresa}}</div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '1'" class="pa-4">
          <div class="text-center mb-4">
            <v-img
              :src="info_invitation.guest.avatar"
              position="center center"
              class="grey lighten-2 elevation-2"
              style="border-radius: 12px; max-height: 200px; max-width: 200px; margin: 0 auto;"
            ></v-img>
          </div>
          <v-card class="mb-3 elevation-1" color="primary">
            <v-card-text class="white--text pa-4 text-center">
              <div class="caption white--text opacity-9 mb-2">{{$t('Visitante')}}</div>
              <div class="headline font-weight-bold white--text">{{ info_invitation.guest.first_name}} {{ info_invitation.guest.last_name}}</div>
            </v-card-text>
          </v-card>
          <v-card class="elevation-1" color="primary">
            <v-card-text class="white--text pa-4 text-center">
              <div class="caption white--text opacity-9 mb-2">{{$t('Parque')}}</div>
              <div class="headline font-weight-bold white--text">{{ info_invitation.invitation.park_name}}</div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '2'" class="pa-4">
          <div class="text-center mb-4">
            <v-img
              :src="info_invitation.guest_Avatar || info_invitation.avatar"
              position="center center"
              class="grey lighten-2 elevation-2"
              style="border-radius: 12px; max-height: 200px; max-width: 200px; margin: 0 auto;"
            ></v-img>
          </div>
          <v-card class="mb-3 elevation-1" color="primary">
            <v-card-text class="white--text pa-4 text-center">
              <div class="caption white--text opacity-9 mb-2">{{$t('Visitante')}}</div>
              <div class="headline font-weight-bold white--text">{{ info_invitation.guest_first_name }} {{ info_invitation.guest_last_name }}</div>
            </v-card-text>
          </v-card>
          <v-card class="elevation-1" color="primary">
            <v-card-text class="white--text pa-4 text-center">
              <div class="caption white--text opacity-9 mb-2">Empresa origen</div>
              <div class="headline font-weight-bold white--text">{{ info_invitation.company_name }}</div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn large color="error" @click="closeAccessDialog()">{{this.$t('cerrar')}}</v-btn>
          <v-btn large color="success" @click="closeAccessDialog()">{{$t('acceso')}}</v-btn>
        </v-card-actions>
      </v-card>

      <!-- SALIDA -->
      <v-card v-if="salida" color="blue-grey lighten-4" class="elevation-5 center">
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{$t('form_salida')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="align-self-end" color="red" icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '0'" class="pa-4">
          <div class="text-center mb-4">
            <v-img
              :src="(info_invitation.user && info_invitation.user.avatar) || info_invitation.guest_Avatar || info_invitation.avatar"
              position="center center"
              class="grey lighten-2 elevation-2"
              style="border-radius: 12px; max-height: 200px; max-width: 200px; margin: 0 auto;"
            ></v-img>
          </div>
          <v-card class="mb-3 elevation-1" color="primary">
            <v-card-text class="white--text pa-3 text-center">
              <div class="caption white--text opacity-9 mb-1">{{$t('Visitante')}}</div>
              <div class="subheading font-weight-bold white--text">{{ info_invitation.guestFirstName}} {{ info_invitation.guestLastName}}</div>
            </v-card-text>
          </v-card>
          <v-card class="elevation-1" color="primary">
            <v-card-text class="white--text pa-3 text-center">
              <div class="caption white--text opacity-9 mb-1">{{$t('Empresa')}}</div>
              <div class="subheading font-weight-bold white--text">{{ info_invitation.empresa}}</div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '1'" class="pa-4">
          <div class="text-center mb-4">
            <v-img
              :src="info_invitation.guest.avatar"
              position="center center"
              class="grey lighten-2 elevation-2"
              style="border-radius: 12px; max-height: 200px; max-width: 200px; margin: 0 auto;"
            ></v-img>
          </div>
          <v-card class="mb-3 elevation-1" color="primary">
            <v-card-text class="white--text pa-4 text-center">
              <div class="caption white--text opacity-9 mb-2">{{$t('Visitante')}}</div>
              <div class="headline font-weight-bold white--text">{{ info_invitation.guest.first_name}} {{ info_invitation.guest.last_name}}</div>
            </v-card-text>
          </v-card>
          <v-card class="elevation-1" color="primary">
            <v-card-text class="white--text pa-4 text-center">
              <div class="caption white--text opacity-9 mb-2">{{$t('Parque')}}</div>
              <div class="headline font-weight-bold white--text">{{ info_invitation.invitation.park_name}}</div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '2'" class="pa-4">
          <div class="text-center mb-4">
            <v-img
              :src="(info_invitation.user && info_invitation.user.avatar) || info_invitation.guest_Avatar || info_invitation.avatar"
              position="center center"
              class="grey lighten-2 elevation-2"
              style="border-radius: 12px; max-height: 200px; max-width: 200px; margin: 0 auto;"
            ></v-img>
          </div>
          <v-card class="mb-3 elevation-1" color="primary">
            <v-card-text class="white--text pa-4 text-center">
              <div class="caption white--text opacity-9 mb-2">{{$t('Visitante')}}</div>
              <div class="headline font-weight-bold white--text">{{ info_invitation.guest_first_name }} {{ info_invitation.guest_last_name }}</div>
            </v-card-text>
          </v-card>
          <v-card class="elevation-1" color="primary">
            <v-card-text class="white--text pa-4 text-center">
              <div class="caption white--text opacity-9 mb-2">Empresa origen</div>
              <div class="headline font-weight-bold white--text">{{ info_invitation.company_name }}</div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn large color="error" @click="closeAccessDialog()">{{ $t('cerrar')}}</v-btn>
          <v-btn large color="success" @click="closeAccessDialog()">{{$t('registrar_salida')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Header fuera del container para no añadir margen -->
    <div class="view-header">
      <h2 class="subheading grey--text">{{$t('entradas_salidas')}}</h2>
      <v-spacer></v-spacer>
      <v-badge v-if="isPollingDeviceReconnect" color="warning" content="Reconectando...">
        <v-btn
          icon
          small
          @click="dialogCameraOptions = true"
          :loading="loadingCameras || loadingRestart"
          title="Esperando reconexión del dispositivo..."
        >
          <v-icon small>refresh</v-icon>
        </v-btn>
      </v-badge>
      <v-btn
        v-else
        icon
        small
        @click="dialogCameraOptions = true"
        :loading="loadingCameras || loadingRestart"
        title="Recargar / Reiniciar"
      >
        <v-icon small>refresh</v-icon>
      </v-btn>
      <v-btn icon small @click="dialogIP = true" title="Configurar">
        <v-icon small>settings</v-icon>
      </v-btn>
    </div>

    <v-container fluid class="pa-0 ma-0">
      <v-layout row wrap>
        <!-- Grid de Cámaras -->
        <v-flex xs12 v-if="cameras.length > 0">
          <div class="cameras-grid">
            <div
              v-for="camera in cameras"
              :key="camera.id"
              class="camera-item"
            >
              <div class="camera-name">{{ camera.name }}</div>
              <CameraAccessCard
                :camera="camera"
                :stream-status="getStreamStatus(camera.id)"
                :scanning-enabled="scanningEnabled"
                @qr-detected="handleQRDetected"
                @restart-camera="restartCamera"
              />
            </div>
          </div>

          <!-- Input Manual de QR -->
          <div class="qr-manual-wrapper">
            <v-form @submit.prevent="submitManualQR()" class="qr-input-form">
              <v-layout row class="align-center">
                <v-flex xs10>
                  <v-text-field
                    v-model="manualQRInput"
                    dense
                    outlined
                    label="QR manual (aplica a todas las cámaras)"
                    prepend-icon="select_all"
                    @keyup.enter="submitManualQR"
                    class="mb-0"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 class="pl-2">
                  <v-btn color="primary" type="submit" block height="40">OK</v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </div>
        </v-flex>

        <!-- Sin Cámaras -->
        <v-flex xs12 v-else-if="initialLoadAttempted && cameras.length === 0">
          <v-card class="elevation-7 pa-5 text-xs-center mx-auto" style="max-width: 500px;">
            <v-icon x-large color="grey" class="mb-3">videocam_off</v-icon>
            <h3>No hay cámaras configuradas</h3>
            <p class="grey--text mt-2">
              Verifica que el servidor esté corriendo en:
              <br>
              <strong>http://{{ serverIP }}/api/cameras</strong>
            </p>
            <v-btn color="primary" @click="dialogIP = true" class="mt-4">
              <v-icon left>settings</v-icon>
              Configurar Servidor
            </v-btn>
          </v-card>
        </v-flex>

        <!-- Cargando -->
        <v-flex xs12 v-else class="text-xs-center py-5">
          <v-progress-circular indeterminate color="primary" class="mb-3"></v-progress-circular>
          <p>Cargando cámaras...</p>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'
import { mapState } from 'vuex'
import axios from 'axios'
import CameraAccessCard from '@/components/CameraAccessCard.vue'

export default {
  name: 'camera_access',
  components: {
    CameraAccessCard
  },
  data() {
    return {
      // Cámaras
      cameras: [],
      streams: [],
      serverIP: localStorage.getItem('camera_server_ip') || '127.0.0.1:7000',
      dialogIP: false,
      dialogCameraOptions: false,
      dialogRestartCamera: false,
      dialogRestartDevice: false,
      dialogConfirmRestartDevice: false,
      selectedCameraToRestart: null,
      selectedCameraToRestartDevice: null,
      loadingCameras: false,
      loadingRestart: false,
      loadingRestartDevice: false,
      initialLoadAttempted: false,
      refreshInterval: null,
      pollingRestartInterval: null,
      isPollingDeviceReconnect: false,
      lastDetectedQR: null,
      lastDetectedTime: 0,

      // QR y Acceso (de check_in_out)
      qr_code: '',
      info_invitation: [],
      valido: false,
      salida: false,
      entrada: false,
      data_access: [],
      errores_guard: '',
      head_color: '',
      band_gafete: false,

      // Modales
      dialog: false,
      dialog_errores: false,
      dialog_inicio: false,
      dialogError: false,
      dialogSuccess: false,
      errorMessage: '',
      successMessage: '',

      // Casetas
      casetas: [],
      caseta: 0,
      loading: false,

      // Dispositivos del parque industrial (CRÍTICO)
      industrial_park_devices: [],
      loading_devices: false,

      // Otros
      loading_gafete: false,
      manualQRInput: '',

      // Control de escaneo
      scanningEnabled: true,

      // Cache para cameraAPI
      _cameraAPI: null
    }
  },
  computed: {
    ...mapState(['caseta_vigilante']),
    onlineCount() {
      return this.streams.filter(s => s.is_online).length
    },
    offlineCount() {
      return this.streams.filter(s => !s.is_online).length
    },
    camerasForRestart() {
      return [
        { id: 'all', name: 'Reiniciar todas las cámaras' },
        ...this.cameras
      ]
    },
    cameraAPI() {
      if (!this._cameraAPI) {
        this.initCameraAPI()
      }
      return this._cameraAPI
    }
  },
  async mounted() {
    this.initCameraAPI()
    this.get_casetas()
    this.get_industrial_park_devices()

    if (localStorage.getItem('id_caseta') === null) {
      this.dialog_inicio = true
    }

    await this.loadCameras()
  },
  beforeDestroy() {
    this.stopPollingDeviceReconnect()
  },
  methods: {
    initCameraAPI() {
      const baseURL = `http://${this.serverIP}`
      this._cameraAPI = axios.create({
        baseURL: baseURL,
        headers: { 'Content-Type': 'application/json' }
      })
    },
    async loadCameras() {
      this.loadingCameras = true
      this.initialLoadAttempted = true
      try {
        const res = await this.cameraAPI.get('/api/cameras')
        this.cameras = res.data

        await this.fetchStreams()
        console.log('Cámaras cargadas:', this.cameras)
      } catch (err) {
        console.error('Error cargando cámaras:', err)
        if (!this.isPollingDeviceReconnect) {
          this.showError(
            `No se puede conectar al servidor.\nVerifica que CameraManager esté en: http://${this.serverIP}`
          )
        }
      } finally {
        this.loadingCameras = false
      }
    },
    async fetchStreams() {
      try {
        const res = await this.cameraAPI.get('/api/streams')
        this.streams = res.data.streams || []

        if (this.isPollingDeviceReconnect) {
          this.checkDeviceReconnection()
        }
      } catch (err) {
        console.error('Error fetching streams:', err)
      }
    },
    checkDeviceReconnection() {
      if (!this.isPollingDeviceReconnect || !this.streams || this.streams.length === 0) {
        return
      }

      const allOnline = this.streams.every(stream => stream.is_online === true)

      if (allOnline) {
        this.stopPollingDeviceReconnect()
        this.showSuccess('Dispositivo reconectado exitosamente')
        console.log('Dispositivo reconectado')
      } else {
        const offlineCount = this.streams.filter(s => !s.is_online).length
        console.log(`Esperando reconexión: ${offlineCount} cámara(s) aún offline`)
      }
    },
    getStreamStatus(cameraId) {
      return this.streams.find(s => s.camera_id === cameraId)
    },
    async restartCamera(cameraId) {
      try {
        await this.cameraAPI.post(`/api/cameras/${cameraId}/force-restart`)
        this.showSuccess('Cámara reiniciada')
        await this.fetchStreams()
      } catch (err) {
        this.showError(`Error reiniciando cámara: ${err.message}`)
      }
    },
    async executeRestartCamera() {
      this.loadingRestart = true
      try {
        if (this.selectedCameraToRestart === 'all') {
          await Promise.all(this.cameras.map(camera => this.restartCamera(camera.id)))
          this.showSuccess('Todas las cámaras han sido reiniciadas')
        } else {
          await this.restartCamera(this.selectedCameraToRestart)
        }
        this.dialogRestartCamera = false
        this.selectedCameraToRestart = null
        await this.fetchStreams()
      } catch (err) {
        this.showError(`Error en el restart: ${err.message}`)
      } finally {
        this.loadingRestart = false
      }
    },
    async executeRestartDevice() {
      this.loadingRestartDevice = true
      try {
        await this.cameraAPI.post(`/api/cameras/${this.selectedCameraToRestartDevice}/restart-device`)
        this.showSuccess('Dispositivo reiniciándose... Esperando reconexión automática')
        this.dialogConfirmRestartDevice = false
        this.dialogRestartDevice = false
        this.selectedCameraToRestartDevice = null
        this.isPollingDeviceReconnect = true
        this.startPollingDeviceReconnect()
      } catch (err) {
        const errorMsg = (err.response && err.response.data && err.response.data.detail) || err.message
        this.showError(`Error reiniciando dispositivo: ${errorMsg}`)
      } finally {
        this.loadingRestartDevice = false
      }
    },
    startPollingDeviceReconnect() {
      if (this.pollingRestartInterval) {
        clearInterval(this.pollingRestartInterval)
      }
      this.pollingRestartInterval = setInterval(() => {
        this.loadCameras()
      }, 20000)
    },
    stopPollingDeviceReconnect() {
      if (this.pollingRestartInterval) {
        clearInterval(this.pollingRestartInterval)
        this.pollingRestartInterval = null
      }
      this.isPollingDeviceReconnect = false
    },
    async handleQRDetected(qrCode) {
      const now = Date.now()
      if (this.lastDetectedQR === qrCode && (now - this.lastDetectedTime) < 2000) {
        return
      }

      this.lastDetectedQR = qrCode
      this.lastDetectedTime = now
      this.qr_code = qrCode

      // Pausar el escáner para evitar múltiples lecturas del mismo código
      this.scanningEnabled = false

      this.get_invitation()
    },
    saveServerIP() {
      localStorage.setItem('camera_server_ip', this.serverIP)
      this.dialogIP = false
      this.loadCameras()
    },
    showError(message) {
      this.errorMessage = message
      this.dialogError = true
    },
    showSuccess(message) {
      this.successMessage = message
      this.dialogSuccess = true
      setTimeout(() => {
        this.dialogSuccess = false
      }, 2000)
    },

    // === MÉTODOS DE CASETAS Y DISPOSITIVOS ===
    get_casetas() {
      this.loading = true
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/GuardHouse/ListCreate/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.loading = false
          this.casetas = response.data
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },

    set_caseta() {
      if (this.caseta.id > 0) {
        localStorage.setItem('id_caseta', this.caseta.id)
        localStorage.setItem('id_parque', this.caseta.park)
        this.dialog_inicio = false
      }
    },

    get_industrial_park_devices() {
      this.loading_devices = true
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/Devices/industrial-park-device/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.loading_devices = false
          this.industrial_park_devices = response.data
          console.log('Dispositivos del parque cargados:', this.industrial_park_devices)
        })
        .catch(error => {
          this.loading_devices = false
          console.log('Error al cargar dispositivos del parque:', error)
        })
    },

    activate_park_device(deviceLabel) {
      const id_parque = localStorage.getItem('id_parque')
      const device = this.industrial_park_devices.find(
        d => d.label && d.label.toLowerCase() === deviceLabel.toLowerCase()
      )

      if (!device) {
        console.warn(`Dispositivo con label '${deviceLabel}' no encontrado`)
        return
      }

      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/Devices/industrial-park-device/activate/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          uuid: device.uuid,
          idParque: id_parque
        }
      }

      axios(config)
        .then(response => {
          console.log(`Dispositivo ${deviceLabel} activado exitosamente`, response.data)
        })
        .catch(error => {
          console.log(`Error al activar dispositivo ${deviceLabel}:`, error)
        })
    },

    // === MÉTODOS DE VALIDACIÓN DE QR ===
    get_current_date() {
      const today = new Date()
      let dd = today.getDate()
      let mm = today.getMonth() + 1
      const yyyy = today.getFullYear()

      if (dd < 10) dd = '0' + dd
      if (mm < 10) mm = '0' + mm

      return mm + '/' + dd + '/' + yyyy
    },

    // === MÉTODOS DE VALIDACIÓN DE INVITACIÓN (DE check_in_out) ===
    get_invitation() {
      if (this.qr_code !== '') {
        const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/InvitationPark/all_invitations/' + this.qr_code,
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        }
        axios(config)
          .then(response => {
            this.info_invitation = response.data
            this.valido = true
            this.is_access_in_out_both()
          })
          .catch(error => {
            if (error.request && error.request.status === 404) {
              this.valido = false
              this.clear_without_activate_camera()
              this.errores_guard = this.$t('mensaje_qr_no_valido')
              this.head_color = 'red display-1 text--primary justify-center'
              this.dialog_errores = true
            }
            if (error.request && error.request.status === 401) {
              this.valido = false
              this.clear_without_activate_camera()
              this.errores_guard = this.$t('mensaje_qr_no_parque_empresa')
              this.head_color = 'red display-1 text--primary justify-center'
              this.dialog_errores = true
            }
          })
      }
    },

    is_access_in_out_both() {
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/InvitationAccessPark/QrCode/' + this.qr_code,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.data && response.data.user) {
            this.info_invitation.user = response.data.user
          }
          if (this.info_invitation.type === '0') {
            if (this.info_invitation.typeInv !== 2) {
              if (response.request.status === 204) {
                this.entrada = true
                this.salida = false
                this.dialog = true
                this.create_acceso(true)
              }
              if (response.request.status === 200) {
                if (Object.keys(response.data).length > 0 && response.data.status === 1) {
                  this.data_access = response.data
                  this.entrada = false
                  this.salida = true
                  this.dialog = true
                  this.update_acceso(true)
                }
                if (response.data.status === 2) {
                  if (response.data.multiple_accesses) {
                    this.entrada = true
                    this.salida = false
                    this.dialog = true
                    this.create_acceso(true)
                  } else {
                    this.clear_without_activate_camera()
                    this.head_color = 'orange display-1 text--primary justify-center'
                    this.errores_guard = this.$t('mensaje_acceso_completo')
                    this.dialog_errores = true
                  }
                }
              }
            } else {
              if (response.request.status === 204) {
                this.entrada = true
                this.salida = false
                this.dialog = true
                this.create_acceso(true)
              } else {
                if (response.data.status === 1) {
                  this.entrada = false
                  this.salida = true
                  this.dialog = true
                  this.update_acceso(true)
                } else if (response.data.status === 2) {
                  if (response.data.multiple_accesses) {
                    this.entrada = true
                    this.salida = false
                    this.dialog = true
                    this.create_acceso(true)
                  } else {
                    this.clear_without_activate_camera()
                    this.head_color = 'orange display-1 text--primary'
                    this.errores_guard = this.$t('mensaje_acceso_completo')
                    this.dialog_errores = true
                  }
                } else {
                  const fechaLocal = new Date(this.get_current_date())
                  const readableDate = response.data.dateTime_EntranceAccess.substring(3, 6) + response.data.dateTime_EntranceAccess.substring(0, 2) + response.data.dateTime_EntranceAccess.substring(5, 10)
                  const fechaAccesoEntrada = new Date(readableDate)
                  if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                    this.entrada = true
                    this.salida = false
                    this.dialog = true
                    this.create_acceso(true)
                  } else {
                    this.clear_without_activate_camera()
                    this.head_color = 'orange display-1 text--primary'
                    this.errores_guard = this.$t('mensaje_acceso_completo')
                    this.dialog_errores = true
                  }
                }
              }
            }
          } else if (this.info_invitation.type === '1') {
            if (this.info_invitation.invitation.typeInv !== 2) {
              if (response.request.status === 204) {
                this.entrada = true
                this.salida = false
                this.dialog = true
                this.create_acceso(true)
              }
              if (response.request.status === 200) {
                if (Object.keys(response.data).length > 0 && response.data.status === 1) {
                  this.data_access = response.data
                  this.entrada = false
                  this.salida = true
                  this.dialog = true
                  this.update_acceso(true)
                }
                if (response.data.status === 2) {
                  if (response.data.multiple_accesses) {
                    this.entrada = true
                    this.salida = false
                    this.dialog = true
                    this.create_acceso(true)
                  } else {
                    this.clear_without_activate_camera()
                    this.head_color = 'orange display-1 text--primary justify-center'
                    this.errores_guard = this.$t('mensaje_acceso_completo')
                    this.dialog_errores = true
                  }
                }
              }
            } else {
              if (response.request.status === 204) {
                this.entrada = true
                this.salida = false
                this.dialog = true
                this.create_acceso(true)
              } else {
                if (response.data.status === 1) {
                  this.entrada = false
                  this.salida = true
                  this.dialog = true
                  this.update_acceso(true)
                } else if (response.data.status === 2) {
                  if (response.data.multiple_accesses) {
                    this.entrada = true
                    this.salida = false
                    this.dialog = true
                    this.create_acceso(true)
                  } else {
                    this.clear_without_activate_camera()
                    this.head_color = 'orange display-1 text--primary'
                    this.errores_guard = this.$t('mensaje_acceso_completo')
                    this.dialog_errores = true
                  }
                } else {
                  const fechaLocal = new Date(this.get_current_date())
                  const readableDate = response.data.dateTime_EntranceAccess.substring(3, 6) + response.data.dateTime_EntranceAccess.substring(0, 2) + response.data.dateTime_EntranceAccess.substring(5, 10)
                  const fechaAccesoEntrada = new Date(readableDate)
                  if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                    this.entrada = true
                    this.salida = false
                    this.dialog = true
                    this.create_acceso(true)
                  } else {
                    this.clear_without_activate_camera()
                    this.head_color = 'orange display-1 text--primary'
                    this.errores_guard = this.$t('mensaje_acceso_completo')
                    this.dialog_errores = true
                  }
                }
              }
            }
          } else if (this.info_invitation.type === '2') {
            if (response.request.status === 204) {
              this.entrada = true
              this.salida = false
              this.dialog = true
              this.create_acceso(true)
            }
            if (response.request.status === 200) {
              if (Object.keys(response.data).length > 0 && response.data.status === 1) {
                this.data_access = response.data
                this.entrada = false
                this.salida = true
                this.dialog = true
                this.update_acceso(true)
              }
              if (response.data.status === 2) {
                if (response.data.multiple_accesses) {
                  this.entrada = true
                  this.salida = false
                  this.dialog = true
                  this.create_acceso(true)
                } else {
                  this.clear_without_activate_camera()
                  this.head_color = 'orange display-1 text--primary justify-center'
                  this.errores_guard = this.$t('mensaje_acceso_completo')
                  this.dialog_errores = true
                }
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    create_acceso(isAuto = false) {
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/InvitationAccessPark/create/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          guardhouse: localStorage.getItem('id_caseta'),
          qr_code: this.qr_code
        }
      }
      axios(config)
        .then(response => {
          if (isAuto) {
            this.activate_park_device('entrada')
          } else {
            this.clear_without_activate_camera()
            this.errores_guard = this.$t('mensaje_alta_acceso_in')
            this.head_color = 'green display-1 text--primary justify-center'
            this.dialog_errores = true
          }
        })
        .catch(error => {
          let errorMessage = this.$t('msg_error')
          if (error.response && error.response.status === 400) {
            if (error.response.data && error.response.data.Error && error.response.data.Error.includes('repetido')) {
              this.activate_park_device('entrada')
              this.clear_without_activate_camera()
              this.errores_guard = this.$t('mensaje_alta_acceso_in')
              this.head_color = 'green display-1 text--primary justify-center'
              this.dialog_errores = true
              return
            }

            if (Array.isArray(error.response.data) && error.response.data[0] && error.response.data[0].code === '08') {
              this.activate_park_device('entrada')
              this.clear_without_activate_camera()
              this.errores_guard = this.$t('mensaje_alta_acceso_in')
              this.head_color = 'green display-1 text--primary justify-center'
              this.dialog_errores = true
              return
            }

            // Extraer mensaje de error del array o del objeto
            if (Array.isArray(error.response.data) && error.response.data.length > 1 && error.response.data[1].detail) {
              errorMessage = error.response.data[1].detail
            } else if (error.response.data.detail) {
              if (error.response.data.code === '05' && this.info_invitation.type === '2') {
                errorMessage = 'Pendiente de autorizacion de supervisor'
              } else {
                errorMessage = error.response.data.detail
              }
            } else if (typeof error.response.data === 'string') {
              errorMessage = error.response.data
            }
          }

          if (isAuto) {
            this.dialog = false
            this.errores_guard = errorMessage
            this.head_color = 'red display-1 text--primary justify-center'
            this.dialog_errores = true
          } else {
            this.clear_without_activate_camera()
            this.head_color = 'red display-1 text--primary justify-center'
            this.errores_guard = errorMessage
            this.dialog_errores = true
          }
        })
    },

    update_acceso(isAuto = false) {
      let URL = ''
      if (this.info_invitation.type === '0') {
        URL = 'https://empresa-service.intrare.app/InvitationAccessPark/updateAccessCodePark/' + this.qr_code + '/'
      } else {
        URL = 'https://empresa-service.intrare.app/InvitationAccessPark/updateAccessInvitationPark/' + this.qr_code + '/'
      }
      const config = {
        method: 'PATCH',
        url: URL,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (isAuto) {
            this.activate_park_device('salida')
          } else {
            this.clear_without_activate_camera()
            this.head_color = 'green display-1 text--primary justify-center'
            this.errores_guard = this.$t('mensaje_alta_acceso_out')
            this.dialog_errores = true
          }
        })
        .catch(error => {
          let errorMessage = this.$t('msg_error')
          if (error.response && error.response.status === 404) {
            this.activate_park_device('salida')
            this.clear_without_activate_camera()
            this.errores_guard = this.$t('mensaje_alta_acceso_out')
            this.head_color = 'green display-1 text--primary justify-center'
            this.dialog_errores = true
            return
          }

          if (error.response && error.response.status === 400) {
            if (error.response.data && error.response.data.Error && error.response.data.Error.includes('repetido')) {
              this.activate_park_device('salida')
              this.clear_without_activate_camera()
              this.errores_guard = this.$t('mensaje_alta_acceso_out')
              this.head_color = 'green display-1 text--primary justify-center'
              this.dialog_errores = true
              return
            }

            if (error.response.data && error.response.data.detail && error.response.data.detail.includes('No encontrado')) {
              this.activate_park_device('salida')
              this.clear_without_activate_camera()
              this.errores_guard = this.$t('mensaje_alta_acceso_out')
              this.head_color = 'green display-1 text--primary justify-center'
              this.dialog_errores = true
              return
            }

            // Extraer mensaje de error
            if (Array.isArray(error.response.data) && error.response.data.length > 1 && error.response.data[1].detail) {
              errorMessage = error.response.data[1].detail
            } else if (error.response.data.detail) {
              errorMessage = error.response.data.detail
            } else if (typeof error.response.data === 'string') {
              errorMessage = error.response.data
            }
          }

          if (isAuto) {
            this.dialog = false
            this.errores_guard = errorMessage
            this.head_color = 'red display-1 text--primary justify-center'
            this.dialog_errores = true
          } else {
            this.clear_without_activate_camera()
            this.head_color = 'red display-1 text--primary justify-center'
            this.errores_guard = errorMessage
            this.dialog_errores = true
          }
        })
    },

    closeAccessDialog() {
      this.dialog = false
      this.qr_code = ''
      this.entrada = false
      this.salida = false
      // Reactivar el escáner después de completar el acceso
      this.scanningEnabled = true
    },

    closeErrorDialog() {
      this.dialogError = false
      this.errorMessage = ''
      // Reactivar el escáner al cerrar error
      this.scanningEnabled = true
    },

    closeSuccessDialog() {
      this.dialogSuccess = false
      this.successMessage = ''
      // Reactivar el escáner al cerrar éxito
      this.scanningEnabled = true
    },

    closeGuardErrorDialog() {
      this.dialog_errores = false
      this.errores_guard = ''
      this.band_gafete = false
      // Reactivar el escáner al cerrar error del guardia
      this.scanningEnabled = true
    },

    clear_without_activate_camera() {
      this.dialog = false
      this.qr_code = ''
      this.entrada = false
      this.salida = false
    },

    submitManualQR() {
      if (this.manualQRInput.trim()) {
        this.handleQRDetected(this.manualQRInput.trim())
        this.manualQRInput = ''
      }
    }
  }
}
</script>

<style scoped>
.camera-access-view {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.view-header {
  display: flex;
  align-items: center;
  padding: 8px 16px 4px;
}

.cameras-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px;
  width: 100%;
}

.camera-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.camera-name {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  padding: 4px 6px 2px;
  background: rgba(0, 0, 0, 0.04);
}

.qr-manual-wrapper {
  padding: 12px 4px 4px;
}

.qr-input-form {
  width: 100%;
  background: rgba(25, 118, 210, 0.06);
  padding: 12px 16px;
  border-radius: 8px;
  border: 2px solid rgba(25, 118, 210, 0.25);
}

.qr-input-form :deep(.v-text-field) {
  margin-bottom: 0 !important;
}

.pl-2 {
  padding-left: 8px !important;
}
</style>
